import { writable } from 'svelte/store';

import type { ApplicationMode } from './mode';

/** The mode to return to when checkout is left. */
export const previousMode = writable<ApplicationMode>('classic');

/** What a completed order carries to the success view. */
export interface OrderDetails {
  orderId: string;
  customer: {
    firstName: string;
    lastName: string;
    email: string;
    company: string;
    salutation: string;
    address: {
      street: string;
      house: string;
      city: string;
      zipCode: string;
      country: string;
    };
  };
  companyCount: number;
  contactCount: number;
  total: number;
}

// Typed rather than `writable(null)`, which infers Writable<null> and makes
// every real assignment an error.
export const orderDetails = writable<OrderDetails | null>(null);
